import { RootApp } from '@web/entry'
import { installConsoleWarningFilter } from '@web/libs/console-warnings'
import { installTmaFullscreen } from '@web/libs/tg/install-fullscreen'
import { installTmaSwipeBehavior } from '@web/libs/tg/install-swipe-behavior'
import { installWebFontScalingLock } from '@web/libs/viewport/install-web-font-scaling-lock'
import { installWebViewportSync } from '@web/libs/viewport/install-web-viewport-sync'
import '@shared-ui/assets/fonts/fonts.css'
import '@web/themes/styles/global.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

installConsoleWarningFilter()
installTmaSwipeBehavior()
installWebFontScalingLock()
installWebViewportSync()
installTmaFullscreen()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <RootApp />
  </StrictMode>,
)
